import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/date-picker.css";
import { FieldTitle, useInput } from "react-admin";
import { TextField } from "@mui/material";

const DatePickerInput = ({ source, label, ...rest }) => {
  const {
    field
  } = useInput({ source });

  return (
    <div>      
      <DatePicker
        id={source}
        selected={field.value ? new Date(field.value) : null}
        onChange={(date) => field.onChange(date ? date.toISOString() : null)}
        popperPlacement="top-start"
        popperModifiers={[
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
            },
          },
        ]}
        portalId="root"
        customInput={
          <TextField            
            variant="outlined"
            size="small"
            label={
              <FieldTitle
                label={label}
                source={source}                  
              />
            }
            fullWidth
          />
        }
        wrapperClassName="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-formControl MuiInputBase-sizeSmall"        
        peekNextMonth
        maxDate={new Date()}        
        showMonthDropdown
        showYearDropdown
        dateFormat="dd/MM/yyyy"
        dropdownMode="select"
        isClearable={true}
        {...rest}
      />
    </div>
  );
};

export default DatePickerInput;